// Decorative preview only: fictitious people allowed by AGENTS.md, never real contacts.
const sample = (id, name, email, phoneNumber, city, companyName, profile) => ({
  id,
  name,
  email,
  phoneNumber,
  thumbnail: '',
  availabilityStatus: 'offline',
  lastActivityAt: null,
  additionalAttributes: {
    city,
    country: 'Brazil',
    countryCode: 'BR',
    companyName,
  },
  customAttributes: {},
  talkviaProfile: profile,
  talkviaProposals: {},
});

export default [
  sample(
    104,
    'Tom Martins',
    'tom.martins@example.com',
    '+5511900000001',
    'São Paulo',
    'Martins Comércio',
    { cpf: '00000000191', age: 38 }
  ),
  sample(
    103,
    'Letícia Gonçalves',
    'leticia.goncalves@example.com',
    '+5521900000002',
    'Rio de Janeiro',
    '',
    { age: 29 }
  ),
  sample(
    102,
    'Wagner Oliveira',
    'wagner.oliveira@example.com',
    '+5531900000003',
    'Belo Horizonte',
    'Oliveira Serviços',
    {}
  ),
  sample(
    101,
    'Luigi Lima',
    'luigi.lima@example.com',
    '+5541900000004',
    'Curitiba',
    '',
    {}
  ),
];
